import { useCallback } from 'react';
import { useDispatch } from 'react-redux';
import { updateInitialState } from '#action/list-filter';
import { getRelatedTo } from '#component/general/list-filter/helper';

export const useUpdateInitialState = () => {
  const dispatch = useDispatch();
  const relatedTo = getRelatedTo();

  return useCallback(async newState => {
    dispatch(updateInitialState(newState, relatedTo));
  }, [dispatch, relatedTo]);
};
